import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appConfirmEqualValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ConfirmEqualValidatorDirective, multi: true }],
  standalone: false,
})
export class ConfirmEqualValidatorDirective implements Validator {
  @Input() public appConfirmEqualValidator: string;
  public validate(control: AbstractControl): ValidationErrors {
    const controlToCompare: AbstractControl = control.parent.get(this.appConfirmEqualValidator);
    return controlToCompare && controlToCompare.value === control.value ? null : { notEqual: true };
  }
}
